import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledCountValue = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.orange[400])}
`;

export const StyledNewResultBlock = styled(FlexColumn)`
    align-items: center;
    padding: 6px 0;

    &:hover {
        cursor: pointer;
        border-radius: 6px;
        background: rgba(182, 190, 198, 0.2);
    }
`;

export const StyledListCaption = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height:14px;
    width: 99px;
    text-align: center;
`;
